<template>
  <modal :title="$t('customization.upload')">
    <upload-list @select-upload="closeModalAfter(() => selectUpload($event))" />
  </modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import UploadList from './UploadList';
import Redirect from '@/mixins/redirect';
import { mapActions } from 'pinia/dist/pinia';
import { useControlLayerStore } from '@/store-pinia/control-layer';

export default {
  name: 'UploadDesignAdd',
  components: {
    UploadList,
    Modal
  },
  mixins: [TrackingMixin, Redirect],
  methods: {
    selectUpload(upload) {
      this.addUploadElement(upload.srcFile);
      this.$root.$emit('reset-navigation');
      this.trackEvent({
        action: 'UploadImage'
      });
    },
    ...mapActions(useControlLayerStore, ['addUploadElement'])
  }
};
</script>
